export enum CentralErrorCodes {
  UNKNOWN_AUTH_TOKEN_ERROR = "2000",
  REVOKED_TOKEN = "2001",
  INVALID_TOKEN = "2002",
  EXPIRED_TOKEN = "2003",
}

export const DEFAULT_RETRY_COUNT = 3;
export const PREVENT_RETRY_LIST: string[] = [
  "551",
  "723",
  "565",
  CentralErrorCodes.INVALID_TOKEN,
  CentralErrorCodes.REVOKED_TOKEN,
  CentralErrorCodes.EXPIRED_TOKEN,
  CentralErrorCodes.UNKNOWN_AUTH_TOKEN_ERROR,
];
